import type { SectionItem } from "@/mocks/home";
import { sections } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

const toneMap: Record<SectionItem["tone"], { icon: string; chip: string }> = {
  primary: { icon: "bg-primary-100 text-primary-700", chip: "bg-primary-100 text-primary-700" },
  accent: { icon: "bg-accent-100 text-accent-700", chip: "bg-accent-100 text-accent-700" },
  secondary: { icon: "bg-secondary-100 text-secondary-800", chip: "bg-secondary-100 text-secondary-800" },
};

export default function SectionGrid() {
  return (
    <section id="sections" className="w-full border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          icon="ri-layout-masonry-line"
          eyebrow="分区导航 · SECTIONS"
          title="按领域分好的六个常驻分区"
          desc="线报按题材归入不同分区，各自有独立的话题标签与值班编辑。找线索先选分区，效率会高很多。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {sections.map((section, index) => {
            const tone = toneMap[section.tone];
            return (
              <Reveal key={section.id} delay={index * 50}>
                <a
                  href="#leaks"
                  className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-300 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300"
                >
                  <div className="flex items-start justify-between">
                    <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${tone.icon}`}>
                      <i className={`${section.icon} text-xl`} />
                    </span>
                    <span className={`rounded-full px-2.5 py-1 text-[11px] font-label ${tone.chip}`}>
                      {section.count}
                    </span>
                  </div>

                  <h4 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {section.name}
                  </h4>
                  <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">
                    {section.desc}
                  </p>

                  <span className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-700">
                    进入分区
                    <span className="flex h-4 w-4 items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}